/* global dataLayer */

import Cookies from 'js-cookie';

let cookieOptions = {
	expires: 365,
	sameSite: 'strict',
};

export function init() {
	const cookieName = 'cookie-notice';
	const className = 'is-hidden';
	const cookieFooter = document.querySelector('.js-cookie-footer');
	const cookieToggle = document.querySelector('.js-cookie-toggle');

	let consented = undefined;
	let cookieButton = document.querySelectorAll('.js-cookie-button');
	let cookieButtonAllow = document.querySelectorAll('.js-cookie-allow');
	let cookieButtonDisallow = document.querySelectorAll('.js-cookie-disallow');
	let cookieRadioButtonAllow = document.querySelectorAll('.js-cookie-radio-allow');
	let cookieRadioButtonDisallow = document.querySelectorAll('.js-cookie-radio-disallow');

	cookieButton.forEach(elem => elem.addEventListener('click', e => hide(e)));

	cookieButtonAllow.forEach(elem => elem.addEventListener('click', () => {
		allow();
		setConsent(true);
	}));
	cookieButtonDisallow.forEach(elem => elem.addEventListener('click', () => {
		disallow();
		setConsent(false);
	}));

	function init() {
		consented = getConsent();

		if (consented == undefined) {
			show();
			return;
		}

		if (!consented) {
			disallow();
			return;
		}

		allow();
	}

	function getConsent() {
		let value = Cookies.get(cookieName);

		if (value === undefined) {
			return undefined;
		}

		return value === 'true';
	}

	function getElements() {
		return Array.from(document.querySelectorAll('[data-tracking-consent]'));
	}

	function loadAll() {
		loadScript(getElements());
	}

	function loadScript(element) {
		if (Array.isArray(element)) {
			return element.forEach(element => loadScript(element));
		}

		if (element.getAttribute('data-tracking-consent') !== '') {
			return element.setAttribute('src', element.getAttribute('data-tracking-consent'));
		}

		if (element instanceof HTMLScriptElement && element.hasAttribute('type')) {
			return loadInlineScript(element);
		}
	}

	function loadInlineScript(script) {
		let clone = script.cloneNode(true);

		clone.setAttribute('type', 'text/javascript');

		script.after(clone);
		script.remove();
	}

	function hide() {
		cookieFooter.classList.add(className);
	}

	function show() {
		cookieFooter.classList.remove(className);
	}

	function toggleCookiesOn() {
		if (cookieToggle) {
			cookieRadioButtonAllow.forEach(elem => elem.checked = true);
			cookieRadioButtonDisallow.forEach(elem => elem.checked = false);
		}
	}

	function toggleCookiesOff() {
		if (cookieToggle) {
			cookieRadioButtonAllow.forEach(elem => elem.checked = false);
			cookieRadioButtonDisallow.forEach(elem => elem.checked = true);
		}
	}

	function setConsent(value) {
		Cookies.set(cookieName, value, cookieOptions);
	}

	function allow() {
		toggleCookiesOn();
		loadAll();

		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({ event: 'cookie_consent_given' });
		}
	}

	function disallow() {
		toggleCookiesOff();
	}

	init();
}
